import { useRef, useState } from 'react';

export function TiltCard({ children }: { children: React.ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const [tilt, setTilt] = useState({ x: 0, y: 0 });
  const [active, setActive] = useState(false);
  const reducedMotion =
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onMouseMove(e: React.MouseEvent<HTMLDivElement>) {
    if (reducedMotion) return;
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    const x = (e.clientX - r.left) / r.width;
    const y = (e.clientY - r.top) / r.height;
    setTilt({ x: (0.5 - y) * 12, y: (x - 0.5) * 12 });
  }

  return (
    <div
      ref={ref}
      onMouseMove={onMouseMove}
      onMouseEnter={() => !reducedMotion && setActive(true)}
      onMouseLeave={() => {
        setTilt({ x: 0, y: 0 });
        setActive(false);
      }}
      className="mt-7"
      style={{
        transform: `perspective(900px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)`,
        transition: active
          ? 'transform 0.08s ease-out'
          : 'transform 0.55s ease-out',
        transformStyle: 'preserve-3d',
      }}
    >
      <div className="bg-white border border-dark-blue/10 shadow-[0_12px_40px_rgba(0,0,0,0.10)] rounded-xl px-6 py-5 overflow-hidden">
        {children}
      </div>
    </div>
  );
}
